(function () {
    "use strict";

    angular.module("app").factory("dopSearchService", dopSearchService);

    dopSearchService.$inject = ["$rootScope", "$filter", "infiniteScrollDataSourceFactory", "dossierService", "habilBootbox"];
    function dopSearchService($rootScope, $filter, infiniteScrollDataSourceFactory, dossierService, habilBootbox) {
        const translator = $filter("habilTranslation");
        
        return {
            openSearchModal
        };

        function openSearchModal(currentSelection, selectedCallback) {

            const scope = Object.assign($rootScope.$new(true), prepareSearchViewModel());

            const selection = angular.copy(currentSelection);

            habilBootbox.customDialog({
                templateUrl: "@/dossiers/dop-search.html",
                scope,
                title: translator("Select_Person_s"),
                size: "large",
                onEscape: true,
                closeButton: true,
                buttons: {
                    submit: {
                        label: translator("Button_Confirm"),
                        className: "btn-primary",
                        callback: () => {
                            selectedCallback(selection);
                            $rootScope.$apply();
                        },
                    },
                    cancel: {
                        label: translator("Button_Cancel"),
                        className: "btn-default"
                    },
                },
            });

            function prepareSearchViewModel() {
                const vm = {
                    isLoadingRequests: false,
                    handleCheckboxClick,
                    isItemSelected,
                };

                vm.DataSource = infiniteScrollDataSourceFactory.CreateChild(modifyFilterAndSearch, (v) => vm.isLoadingRequests = v);

                const pageAndSort = vm.DataSource.GetPageAndSort();

                if (!pageAndSort.SortBy.length) {
                    pageAndSort.SortBy.push({ Name: "DossierPerson.Name", IsReverse: false });
                }

                vm.sortType = pageAndSort.SortBy[0].Name;
                vm.sortReverse = pageAndSort.SortBy[0].IsReverse;

                const filter = vm.DataSource.GetFilter();

                filter.RequireRequest = true;

                return vm;

                function modifyFilterAndSearch(payload, successCallback, errorCallback, finallyCallback) {
                    dossierService.searchOrganisationPersonPaged(payload, successCallback, errorCallback, finallyCallback);
                }

                function handleCheckboxClick($event, item) {
                    if ($event.target.checked) {
                        selection.push(item);
                    } else {
                        let itemIndex = findSelectedItemIndex(item);

                        while (itemIndex >= 0) {
                            selection.splice(itemIndex, 1);
                            itemIndex = findSelectedItemIndex(item);
                        }
                    }
                }

                function isItemSelected(item) {
                    return findSelectedItemIndex(item) >= 0;
                }

                function findSelectedItemIndex(item) {
                    return selection.findIndex(selectedItem => selectedItem.DossierPerson?.ReferenceNbr === item.DossierPerson?.ReferenceNbr);
                }

            }
        }
    }
})();

